import {TranslationKeys} from '@colonist/i18n'

export enum GameTypeEnum {
    Unknown = 0,
    Tutorial = 1,
    BotGame = 2,
    CreatedRoomGame = 3,
    MatchmakingGame = 5,
    MatchmakingGameRanked = 6,
    BeginnerMode = 7,
    CreatedTournamentRoom = 8,
}

export enum ModeSettingEnum {
    Classic4P = 0,
    TutorialClassic4P = 1,
    Classic56P = 2,
    Classic78P = 3,
    Seafarers4P = 4,
    Seafarers56P = 5,
    CitiesAndKnights4P = 6,
    CitiesAndKnights56P = 7,
    CitiesAndKnightsSeafarers4P = 8,
    CitiesAndKnightsSeafarers56P = 9,
    ServerStressTestClassic4P = 10,
    BeginnerModeClassic4P = 11,
    ColonistRush4P = 12,
}

export enum MapSettingEnum {
    Classic4P = 0,
    TutorialClassic4P = 1,
    Classic4PRandom = 2,
    Classic56P = 3,
    Classic78P = 4,
    // SS# = Seafarers Scenario Map# Map_Name Player#,
    SS1HeadingForNewShores3P = 5,
    SS1HeadingForNewShores4P = 6,
    SS1HeadingForNewShores56P = 7,
    TutorialSS1HeadingForNewShores4P = 8,
    SS2FourIslands3P = 9,
    SS2FourIslands4P = 10,
    SS2SixIslands56P = 11,
    TutorialSS2FourIslands4P = 12,
    SS3FogIslands3P = 13,
    SS3FogIslands4P = 14,
    SS3FogIslands56P = 15,
    TutorialSS3FogIsland4P = 16,
    SS4ThroughTheDesert3P = 17,
    SS4ThroughTheDesert4P = 18,
    SS4ThroughTheDesert56P = 19,
    TutorialSS4ThroughTheDesert4P = 20,
    KingOfTheHill = 21,
    Earth = 22,
    EarthSeafarers = 23,
    USA = 24,
    UK = 25,
    UKSeafarers = 26,
    Diamond = 27,
    Gear = 28,
    Lakes = 29,
    Pond = 30,
    Twirl = 31,
    ShuffleBoard = 32,
    BlackForest = 33,
    Volcano = 34,
    Circle = 35,
    Kite = 36,
    Romania = 37,
    MiniBase = 38,
    Monopoly = 39,
    MountainOfRiches = 40,
    Doggo = 41,
    Duel = 42,
    TradeIslands = 43,
    TradeIslandsSeafarers = 44,
    Vietnam = 45,
    TurningTidesSeafarers = 46,
    TurningTidesClassic = 47,
    TwoIsles = 48,
    JellyFish = 49,
    GoldRush = 50,
    Istanbul = 51,
    IstanbulSeafarers = 52,
    Europe = 53,
    EuropeSeafarers = 54,
    Stripes = 55,
    MonopolyIslands = 56,
    MonopolyIslandsSeafarers = 57,

    CampaignLevel1 = 58,
    CampaignLevel2 = 59,

    CampaignRoadRace = 60, // do not remove
    CampaignRoadRace2 = 61, // do not remove

    // legacy code that needs to be updated
    // Spinner,
    // Pangaea,
    // Cyclops,
    // Hourglass,
    // HourglassXL,
    // Snowflake,
    // Australia
}

export const ARCHIVED_MAP_SETTING_ENUMS = [MapSettingEnum.CampaignRoadRace, MapSettingEnum.CampaignRoadRace2]

export function getDefaultMapForGameMode(mode: ModeSettingEnum): MapSettingEnum {
    switch(mode) {
        case ModeSettingEnum.Classic4P:
            return MapSettingEnum.Classic4P
        case ModeSettingEnum.TutorialClassic4P:
            return MapSettingEnum.TutorialClassic4P
        case ModeSettingEnum.BeginnerModeClassic4P:
            return MapSettingEnum.CampaignLevel1
        case ModeSettingEnum.Classic56P:
            return MapSettingEnum.Classic56P
        case ModeSettingEnum.Classic78P:
            return MapSettingEnum.Classic78P
        case ModeSettingEnum.Seafarers4P:
            return MapSettingEnum.SS1HeadingForNewShores4P
        case ModeSettingEnum.Seafarers56P:
            return MapSettingEnum.SS1HeadingForNewShores56P
        case ModeSettingEnum.CitiesAndKnights4P:
            return MapSettingEnum.Classic4P
        case ModeSettingEnum.CitiesAndKnights56P:
            return MapSettingEnum.Classic56P
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            return MapSettingEnum.SS1HeadingForNewShores4P
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return MapSettingEnum.SS1HeadingForNewShores56P
        case ModeSettingEnum.ServerStressTestClassic4P:
            return MapSettingEnum.TutorialClassic4P
        default:
            return MapSettingEnum.Classic4P
    }
}

export enum GameSpeedSettings {
    Base30s = 0,
    Base60s = 1,
    Base120s = 2,
    Base240s = 3,
    Base12000s = 4,
    Rush5s = 5,
    Rush8s = 6,
    Rush10s = 7,
    Rush15s = 8,
    Rush20s = 9,
    Base15s = 10,
}

export enum ELOTypeEnum {
    Inactive = 0,
    HiddenUnranked1v1 = 1,
    HiddenUnranked4PClassic = 2,
    VisibleRanked1v1 = 3,
    VisibleRanked4PClassic = 4,
    VisibleRankedCitiesAndKnights4P = 5,
    HiddenUnrankedShuffle = 6,
    VisibleRanked4PRush = 7,
}

export enum ExtensionSettingEnum {
    Players4 = 0,
    Players56 = 1,
    Players78 = 2,
}

export enum ScenarioSettingEnum {
    None = 0,
    SS1HeadingForNewShores = 1, // SS# = Seafarers Scenario #
    SS2TheFourIslands = 2,
    SS3TheFogIslands = 3,
    SS4ThroughTheDesert = 4,
    // SS5TheForgottenTribe, // Dev 7, 2020. Jeff for future use.
    // SS6ClothForCatan,
    // SS7ThePirateIslands,
    // SS8TheWondersOfCatan,
    // SS9NewWorld,
}

export enum DiceSettingEnum {
    Random = 0,
    Balanced = 1,
    StressTestSequence = 2,
    PredefinedDiceSequenceDeleted = 3, // do not reuse or remove
}

export enum BotSpeedSettings {
    Fast = 0,
    Normal = 1,
    Slow = 2,
}

export interface GameTimerOption {
    key: GameSpeedSettings
    labelTranslationKey: TranslationKeys
    isDefault?: boolean
}
